import { permissions } from "@/utils/constants";

/**
 * Any of these allows the Makkah-region analytics dashboard route (`/app/makkah`).
 * Matches `view_dashboard_*` keys used by widgets under `makkah/dashboard/*` APIs.
 */
export const MAKKAH_HOME_ANALYTICS_PERMISSIONS = [
  permissions.view_dashboard_summary_makkah,
  permissions.view_dashboard_sections_makkah,
  permissions.view_dashboard_pilgrim_counts_makkah,
  permissions.view_dashboard_visas_by_nationality_makkah,
  permissions.view_dashboard_arrivals_makkah_by_nationality_makkah,
  permissions.view_dashboard_arrivals_madina_by_nationality_makkah,
  permissions.view_dashboard_incidents_latest_makkah,
  permissions.view_dashboard_house_examinations_summary_makkah,
  permissions.view_dashboard_departured_makkah_by_nationality_makkah,
  permissions.view_dashboard_departured_madina_by_nationality_makkah,
  permissions.view_dashboard_arrivals_makkah_region_by_day_makkah,
  permissions.view_dashboard_arrivals_madina_port_by_day_makkah,
];

/**
 * Any of these allows the Madina-region analytics dashboard (`/app/madina`, `/app/madina/dashboard`).
 */
export const MADINA_HOME_ANALYTICS_PERMISSIONS = [
  permissions.view_dashboard_summary_madina,
  permissions.view_dashboard_sections_madina,
  permissions.view_dashboard_pilgrim_counts_madina,
  permissions.view_dashboard_visas_by_nationality_madina,
  permissions.view_dashboard_arrivals_makkah_by_nationality_madina,
  permissions.view_dashboard_arrivals_madina_by_nationality_madina,
  permissions.view_dashboard_incidents_latest_madina,
  permissions.view_dashboard_house_examinations_summary_madina,
  permissions.view_dashboard_departured_makkah_by_nationality_madina,
  permissions.view_dashboard_departured_madina_by_nationality_madina,
  permissions.view_dashboard_arrivals_makkah_region_by_day_madina,
  permissions.view_dashboard_arrivals_madina_port_by_day_madina,
];
